import { useAtom } from "jotai";
import { startTransition, useState } from "react";
import styled from "styled-components/macro";
import { useIsAdmin } from "utils/customHooks/genericHooks";
import { Tooltip } from "@mui/material";
import { isFlightDebuggerOpenAtom } from "../debuggerUtils";

export const HiddenButtonOpensFlightDebugger = () => {
  const isAdminUser = useIsAdmin();
  const clicksToOpenDebugger = isAdminUser ? 1 : 3;
  const [, setIsFlightDebuggerOpen] = useAtom(isFlightDebuggerOpenAtom);

  const [numClicks, setNumClicks] = useState(0);
  const handleClick = () => {
    const newNumClicks = numClicks + 1;
    if (newNumClicks === clicksToOpenDebugger) {
      setNumClicks(0);
      startTransition(() => {
        setIsFlightDebuggerOpen(true);
      });
    } else {
      setNumClicks(newNumClicks);
    }
  };

  return (
    <Tooltip title={isAdminUser ? "Open Flight Debugger" : ""}>
      <HiddenButtonStyles onClick={handleClick} onTouchStart={handleClick} />
    </Tooltip>
  );
};

const HiddenButtonStyles = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 64px;
  height: 64px;
  border: none;
  background: none;
  opacity: 0;
`;
